"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateNumberToFixed = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
function truncateNumberToFixed(value, fraction) {
  if ((0, isNil_1.default)(value)) return 0;
  if ((0, isNil_1.default)(fraction)) return value;
  if (fraction < 1) return Math.floor(value);
  const valueParts = Number(value).toString().split('.');
  if (valueParts.length < 2) return value;
  const result = `${valueParts[0]}.${valueParts[1].substring(0, fraction)}`;
  return parseFloat(result);
}
exports.truncateNumberToFixed = truncateNumberToFixed;